import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./general-pages/general-pages.module').then(m => m.GenralPagesModule),
    data: { title: 'Digital Eye Self-Inspection | Verify Otp' }
  },
  {
    path: 'user-panel',
    loadChildren: () => import('./user-panel/user-panel.module').then(m => m.UserPanelModule),
    data: { title: 'Digital Eye Self-Inspection | User Panel' }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
